import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'app/core/core.module';
import { AngularMaterialModule, SharedModule } from 'app/shared';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardContainer } from './container/dashboard.container';
import { OrdersTileComponent } from './tiles/orders-tile/orders-tile.component';
import { FlowsTileComponent } from './tiles/flows-tile/flows-tile.component';
import { LaunchpadTileComponent } from './tiles/launchpad/launchpad-tile.component';
import { LocalOfficeTileComponent } from './tiles/local-office-tile/local-office-tile.component';
import { ContactComponent } from 'app/modules/dashboard/tiles/local-office-tile/contact/contact.component';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    CoreModule,
    ReactiveFormsModule,
    // AdalModule,
    DashboardRoutingModule,
  ],
  declarations: [DashboardContainer, OrdersTileComponent, FlowsTileComponent, LaunchpadTileComponent, LocalOfficeTileComponent, ContactComponent],
})
export class DashboardModule {}
